import { IFileWithMeta } from "../Control/Dropzone/Dropzone";
import { Document } from "../Entity/Document";
export default class UIHelper {
    public static GetSelectValue<T = unknown>(value: unknown): T | undefined {
        if (value === null || typeof value !== 'object') {
            return undefined;
        }
        const option = value as { value?: T };
        return option.value;
    }

    public static GetSelectStringValue(value: unknown): string | undefined {
        const selectedValue = UIHelper.GetSelectValue<unknown>(value);
        return typeof selectedValue === 'string' ? selectedValue : undefined;
    }

    public static OnChangeCheckBox(e: { target: { name: string } }, value: unknown) {
        //debugger
        return UIHelper.OnChange(e.target.name, value);
    }
    public static OnChangeReactSelect(value: unknown, e: { name?: string; action: string }) {
        if(e.action === "clear") {
            return UIHelper.OnChange(e.name || "", "");
        }
        const selectedValue = UIHelper.GetSelectValue(value) ?? value;
        return UIHelper.OnChange(e.name || "", selectedValue);
    }

    public static OnChangeDropZone(e: IFileWithMeta, s: string, value: IFileWithMeta[], name: string) {

        var actualFiles = value.map(i => i.file);
        if (s === "removed") {
            actualFiles = value.filter(i => { return i.file.name !== e.file.name }).map(i => i.file);
        }
        return UIHelper.OnChange(name, actualFiles);
    }

    public static OnChange<T>(name: string, value: T) {
        var newE = { target: { name: name, value: value, id: name } };
        return newE;
    }

    // public static dataURLtoFile(dataurl:string, filename:string) {

    //         var arr = dataurl.split(',');
    //         var match= arr[0].match(/:(.*?);/);
    //         var mime = match[1];
    //         var bstr = atob(arr[1]); 
    //         var n = bstr.length;
    //         var u8arr = new Uint8Array(n);

    //     while(n--){
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }

    //     return new File([u8arr], filename, {type:mime});
    // }

    // public static urltoFile(url:string, filename:string, mimeType:string){
    //     return (fetch(url)
    //         .then(function(res){return res.arrayBuffer();})
    //         .then(function(buf){return new File([buf], filename,{type:mimeType});})
    //     );
    // }
    public static CreateDocumentFromUrlList(imageUrls: string[]) {
        var files: Document[] = [];
        imageUrls.forEach(i => {
            files.push(UIHelper.CreateDocumentFromUrl(i))
        })
        return files;
    }
    public static async CreateImageFromFileList(imageUrls: Document[]): Promise<File[]> {
        var files: File[] = [];
        return new Promise((resolve, reject) => {
            var count = 0;
            imageUrls.forEach(async (i: Document) => {
                // @ts-ignore
                var tempitem = await UIHelper.CreateImageFromFile(i)
                    .then(res => { return res });
                if (tempitem) {
                    files.push(tempitem);
                }
                count++;
                if (count === imageUrls.length) {
                    resolve(files)
                }
            })

        })
    }
    public static CreateDocumentFromUrl(imageUrl: string) {
        var tempDoc = {} as Document
        tempDoc.DocumentUrl = imageUrl ? imageUrl.replace("localhost:5037", "localhost:5039") : imageUrl;
        return tempDoc;
    }

    public static CreateImageFromFile(imageUrl: Document) {
        if (!imageUrl || !imageUrl.DocumentUrl) {
            return null;
        }

        var fileName = imageUrl.Name || imageUrl.DocumentUrl.split('/').pop() || ""
        var _ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        return fetch(imageUrl.DocumentUrl).then(res => {
            return res.arrayBuffer().then(buf => {
                return new File([buf], fileName, { type: 'image/*' })
                //return new File([buf], fileName, { type: ext })
                //utils accepts preventing which need to fix later

            })
        }).catch(function (e) {
            return null;
        });

    }
}